import { Component, OnInit, ElementRef } from '@angular/core';
import { CertificadoService } from '../services/certificado.service';
import { Subscription } from 'rxjs';
import { HttpUtilService } from '../services/http-util.service';
import { OutorgaService } from '../services/outorga.service';

@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.css']
})
export class HomeComponent implements OnInit {
  sub: Subscription;
  tipoInscricao;
  dadosOutorgante;

  constructor( private httpUtilService: HttpUtilService,
   private outorgaService: OutorgaService) {}
    
  ngOnInit() {
      this.tipoInscricao = this.httpUtilService.obterTipoInscricao();
      this.outorgadoSubscribe();
  }

  outorgadoSubscribe() {
    this.sub = this.outorgaService.getOutorgado()
    .subscribe(response => {
      if (response) {
        this.dadosOutorgante = response[2];
      }
    });
  }

  isPJOuCpfComOutorga() {
    return this.tipoInscricao !== '3' || (this.tipoInscricao ===  '3'  && this.dadosOutorgante);
  }

  ngOnDestroy() {
    this.dadosOutorgante = null;
    this.sub.unsubscribe();
  }
}
